import JSONEditorWrapper from '@buildwise/libs/common/JSONEditor/JSONEditorWrapper';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import CustomDialogTitle from 'components/modal/CustomDialogTitle';
import { ConfigType } from 'config/config';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import _ from 'lodash';
import AlertModal from 'components/utils/AlertModal';
import { hasJsonChanged } from 'utility/helpers';
import { JSONType } from '@buildwise/libs/common/JSONEditor/JSONEditorWrapper';

type EditConfigModalProps = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  config: JSONType;
  onSave: (config: ConfigType) => void;
  loading: boolean;
};

function EditConfigModal({ open, setOpen, config, onSave, loading }: EditConfigModalProps) {
  const [json, setJson] = useState<JSONType>(config);
  const [isModified, setIsModified] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);

  useEffect(() => {
    const hasChanges = hasJsonChanged(config, json);
    setIsModified(hasChanges);
  }, [json]);

  const closeModal = () => {
    setOpen(false);
  };
  const handleSave = () => {
    const updatesJson = json as ConfigType;
    onSave(updatesJson);
  };

  const handleClose = () => {
    if (isModified) {
      setOpenConfirmation(true);
    } else {
      closeModal();
    }
  };

  return (
    <>
      <Dialog
        open={open}
        fullWidth
        maxWidth="md"
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        <CustomDialogTitle onClose={handleClose} id="dialog-title">
          <Typography sx={{ fontSize: '24px', fontWeight: 700, color: 'black' }}>
            Modify Configuration
          </Typography>
        </CustomDialogTitle>
        <DialogContent dividers id="dialog-description" sx={{ padding: 0, height: '500px' }}>
          <JSONEditorWrapper initialJson={json} setJson={setJson} />
        </DialogContent>

        <DialogActions>
          <Button variant="text" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" disabled={!isModified || loading} onClick={handleSave}>
            {loading ? <CircularProgress color="inherit" size={20} /> : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>
      {openConfirmation && (
        <AlertModal
          open={openConfirmation}
          setOpen={setOpenConfirmation}
          handleCancel={() => {
            closeModal();
          }}
          onSubmit={handleSave}
          loading={loading}
          title="Confirm"
          submitButtonName={'Save'}
          cancelButtonName="Discard"
          submitButtonColor="primary"
          description={'Do you want to update the config with new changes?'}
        />
      )}
    </>
  );
}

export default EditConfigModal;
